import {
	defineMessages
} from 'react-intl';

export default defineMessages({
	titleBuy: {
		'id': 'popup.titleBuy',
		'defaultMessage': 'Leave us your email',
	},
	subtitleBuy: {
		'id': 'popup.subtitleBuy',
		'defaultMessage': 'and out sales agent will contact you as soon as possible',
	},
	titleApp: {
		'id': 'popup.titleApp',
		'defaultMessage': 'Should you want to try our application',
	},
	subtitleApp: {
		'id': 'popup.subtitleApp',
		'defaultMessage': 'please leave us your email and our representative will contact you as soon as possible.',
	},
	emailInValid:{
		'id': 'popup.emailInValid',
		'defaultMessage': 'The input is not valid E-mail!',
	},
	email:{
		'id': 'popup.email',
		'defaultMessage': 'Please input your E-mail!',
	},
	placeholder:{
		'id': 'popup.placeholder',
		'defaultMessage': 'Enter your email',
	},
	button:{
		'id': 'popup.button',
		'defaultMessage': 'Send',
	},
	titleCard:{
		'id': 'creditCard.title',
		'defaultMessage': 'You already ordered a product',
	},
	subtitleCard:{
		'id': 'creditCard.subtitle',
		'defaultMessage': 'Please wait a call from our sales team.',
	},
});


// WEBPACK FOOTER //
// ./src/components/Popup/messages.js